import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchPerformanceReport,
  fetchSupervisorDashboard,
  evaluateAutomationGuard,
} from "@app/services/aiSupervisorApi";
import type {
  AiPerformanceReport,
  AutomationGuardRequest,
  AutomationGuardResponse,
  SupervisorDashboardResponse,
} from "@app/services/aiSupervisorApi";

const SUPERVISOR_KEYS = {
  dashboard: ["ai-supervisor", "dashboard"] as const,
  performance: (periodHours: number) => ["ai-supervisor", "performance", periodHours] as const,
};

export function useSupervisorDashboard() {
  return useQuery<SupervisorDashboardResponse>({
    queryKey: SUPERVISOR_KEYS.dashboard,
    queryFn: fetchSupervisorDashboard,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

export function usePerformanceSnapshot(periodHours: number) {
  return useQuery<AiPerformanceReport>({
    queryKey: SUPERVISOR_KEYS.performance(periodHours),
    queryFn: () => fetchPerformanceReport(periodHours),
    staleTime: 60_000,
  });
}

export function useAutomationGuardAssessment() {
  return useMutation<AutomationGuardResponse, Error, AutomationGuardRequest>({
    mutationFn: (payload) => evaluateAutomationGuard(payload),
  });
}

